import React, { useState, useEffect } from 'react';
import usePortalService from '../services/PortalService';
import { Link } from 'react-router-dom';
import { Table, Pagination  } from 'antd';
import type { PaginationProps } from 'antd';
import { ManagerNavbar } from '../Components/Navbars';
import { ColumnsType } from 'antd/es/table';
import { LoaderWithTimer } from '../Components/LoaderWithTimer';

let selectedPage: number;
let candidatePageSize = 10;
export const Rating = () => {
    const { listCandidates } = usePortalService();
    
    const columns: ColumnsType = [
        {
          title: 'Номер',
          dataIndex: 'number',
        },
        {
          title: 'Студент ',
          dataIndex: 'fullName',
          render: (_, record) => (
              <Link to={"/candidate/"+record.id}>{record.fullName}</Link>
          ),
        },
        {
          title: 'Образование ',
          dataIndex: 'educationLevel',
        },
        {
          title: 'Время использования ',
          dataIndex: 'ratingRTSIM',
          align: 'right',
        },
        {
          title: 'Вуз / Ссуз ',
          dataIndex: 'educationalInstitution',
        },
        {
          title: 'Город ',
          dataIndex: 'city',
        },
        // в дизайне ещё дата регистрации, но в ответе пока её нет
      ];

    const [page, setPage] = useState(1);
    const [pageSize, setPageSize] = useState(candidatePageSize);
    const [totalCount, setTotalCount] = useState(0);

    const [candidates, setCandidates] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [hasError, setHasError] = useState(false);

    const pageHandler: PaginationProps['onChange'] = (pageNumber) => {
        setPage(pageNumber)
        selectedPage = pageNumber;
        findCandidates();
    };

    const pageSizeHandler: PaginationProps['onShowSizeChange'] = (current, pageSize) => {
      candidatePageSize = pageSize;
      setPageSize(pageSize)
    };

    useEffect(() => {
      setIsLoading(true);
      setHasError(false);
      setCandidates([]);
      selectedPage = 0
      
      listCandidates({
          offset: 0,
          limit: candidatePageSize,
          sortBy: "UsageTimeInHours",
          sortOrder: 1,
          filter: {
            filterOption: 0,
          }
      }).then(result => {
          setCandidates(result.profiles.items)
          setTotalCount(result.profiles.totalCount)
      }).catch(error => {
          setHasError(true);
          console.log(error)
      }).finally(() => {
        setIsLoading(false);
      })
    }, []);


    const findCandidates = async () => {
        setCandidates([]);
        setIsLoading(true);
        const offset = (selectedPage-1)*candidatePageSize;
        await listCandidates({
            offset,
            limit: candidatePageSize,
            sortBy: "UsageTimeInHours",
            sortOrder: 1,
            filter: {
              filterOption: 0,
            }
        }).then(result => {
          if (result.success) {
            if (offset > result.profiles.totalCount && result.profiles.totalCount != 0) {
              selectedPage = Math.ceil(result.profiles.totalCount/candidatePageSize);
              setPage(selectedPage)
              findCandidates();
            } else {
                setCandidates(result.profiles.items)
                setTotalCount(result.profiles.totalCount)
            }
          }
        }).catch(error => {
          setHasError(true);
          console.log(error)
        }).finally(() => {
          setIsLoading(false);
        });
    }

    return (
        <>
          <ManagerNavbar />
          <div className="basic-container">
              <h1 style={{ marginBottom: '14px'}}> Рейтинг участников </h1>
              <div>
                  {(totalCount !== 0 && !isLoading) ? 
                    <Table columns={columns} dataSource={candidates} pagination={false} style={{marginBottom:'32px'}}/>
                    :
                    <LoaderWithTimer isLoading={isLoading} skeletonStyle="table"/>
                  }
                  {hasError && <p>Произошла ошибка при загрузке. Пожалуйста, попробуйте обновить страницу.</p>}
                  <div>
                      {(totalCount > candidatePageSize && !isLoading && !hasError) && 
                        <Pagination 
                          current={page} 
                          total={totalCount} 
                          onChange={pageHandler} 
                          showSizeChanger
                          pageSize={pageSize} 
                          onShowSizeChange={pageSizeHandler}
                          pageSizeOptions={[100, 50, 30, 20, 15, 10, 5]} 
                          style={{marginLeft:'30%', marginRight:'auto'}}
                        />
                      }
                  </div>
              </div>
          </div>
        </>
    );
};